<template>
  <div class="clock" v-if="hourtime != ''">
    <div class="clock__hours">
      <span class="clock__hourtime" v-text="hourtime"></span>
      <span v-text="hours"></span>
    </div>
    <div class="clock__minutes" v-text="minutes"></div>
    <div class="clock__seconds" v-text="seconds"></div>
  </div>
</template>

<script>
import { getHourTime, getZeroPad } from '../plugins/Filters'

export default {
  data () {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0,
      hourtime: ''
    }
  },
  mounted () {
    this.$options.interval = setInterval(this.updateDateTime, 1000);
  },
  beforeDestroy () {
    clearInterval(this.$options.interval);
  },
  methods: {
    updateDateTime () {
      let now = new Date()

      this.hours = now.getHours()
      this.minutes = getZeroPad(now.getMinutes())
      this.seconds = getZeroPad(now.getSeconds())
      this.hourtime = getHourTime(this.hours)
      this.hours = this.hours
    }
  }
}
</script>

<style scoped>
.clock {
  background: #fff;
  border: .3rem solid #fff;
  border-radius: .5rem;
  display: inline-block;
}

.clock__hours,
.clock__minutes,
.clock__seconds {
  background: linear-gradient(to bottom, #26303b 50%, #2c3540 50%);
  display: inline-block;
  color: #fff;
  font-family: 'Nunito', sans-serif;
  font-size: 1rem;
  font-weight: 300;
  padding: .3rem 1rem;
  text-align: center;
  position: relative;
  height: 30px;
  margin-top: -15px;
}

.clock__hours {
  border-right: .15rem solid #fff;
  border-radius: .5rem 0 0 .5rem;
}

.clock__minutes {
  border-right: .15rem solid #fff;
}

.clock__seconds {
  border-radius: 0 .5rem .5rem 0;
}

.clock__hourtime {
  font-size: 0.5rem;
  position: absolute;
  top: 1px;
  left: 8px;
}
</style>
